const ModulesLoader = require("./modules-loader.js");

module.exports = {
    ModulesLoader,
};
